<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>设备管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/package/index">套餐管理</el-breadcrumb-item>
        <el-breadcrumb-item>套餐列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>套餐列表</span>
        </div>
        <el-button  @click="dialogFormVisible = true" size="small" icon="el-icon-plus" type="primary">添加分类</el-button>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" style="width: 100%" row-key="id" v-loading="loading" default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <!-- <el-table-column prop="id" label="ID" width="100"></el-table-column> -->
          <el-table-column prop="title" label="标题" width="200"></el-table-column>
          <el-table-column prop="length" label="时长(年)" width="160"></el-table-column>
          <el-table-column prop="o_price" label="原价" width="160"></el-table-column>
          <el-table-column prop="price" label="现价" width="160"></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column prop="sort" label="排序" width="80"></el-table-column>
          <el-table-column label="审核" width="80">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
                @change="setStatus(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template #default="scope">
              <el-button size="mini" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background
            layout="total,prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="套餐管理" width="30%" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="标题：" :label-width="formLabelWidth" prop="title">
          <el-input v-model="ruleForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="时长：" :label-width="formLabelWidth" prop="length">
          <el-select v-model="ruleForm.length" placeholder="请选择时长">
            <el-option label="请选择" :value="0"></el-option>
            <el-option label="一年" :value="1"></el-option>
            <el-option label="二年" :value="2"></el-option>
            <el-option label="三年" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原价：" :label-width="formLabelWidth" prop="o_price">
          <el-input v-model="ruleForm.o_price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="现价：" :label-width="formLabelWidth" prop="price">
          <el-input v-model="ruleForm.price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态：" :label-width="formLabelWidth">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序：" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.sort" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      page: 0,
      count: 0,
      limit: 30,
      dialogFormVisible: false,
      ruleForm: {
        title: "",
        length: "",
        price: "",
        o_price: "",
        status: 1,
        sort: "",
      },
      search: {
        keys: "",
      },
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
        length: [{ required: true, message: "请选择时长", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
      },
      formLabelWidth: "80px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
  },
  methods: {
    closeDialog() {
      //this.$refs['ruleForm'].resetFields();
      this.dialogFormVisible = false;
      this.ruleForm.title = '';
      this.ruleForm.length = '';
      this.ruleForm.price = '';
      this.ruleForm.o_price = '';
    },
    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/package/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    setStatus(row) {
      var that = this;
      that.axios
        .post("/package/status", { id: row.id, status: row.status })
        .then((res) => { });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },
    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post("/package/destroy", {
              ids: ids,
            })
            .then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                that.getList();
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            });
        });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.page = that.page;
      formData.limit = that.limit;
      formData.keys = that.search.keys;
      that.axios.post("/package/index", formData).then((res) => {
        if (res) {
          that.tableData = res.data;
          // that.count = res.data.total;
          // that.page = curr_page ? curr_page : that.page;
          // curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/package/store";
        if (that.id) {
          formData.id = that.id;
          url = "/package/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.search-box {
  padding: 0 20px;
}
</style>